import { Modal } from "antd";
import { ceoLetterState } from "../state/atoms";
import { useRecoilState } from "recoil";
import "./CEOLetter.scss";
import CEOSignature from "./icons/CEOSignature";
import { FINAL_DATE_FORMATTED } from "../util/constants";

export default function CEOLetterModal() {
  const [showCeoLetter, setShowCeoLetter] = useRecoilState(ceoLetterState);

  return <Modal className={"ceo-letter-modal clean"} open={showCeoLetter} onCancel={() => setShowCeoLetter(false)} footer={null}>
    <header>
      <h1>Free Plan - It's been a good run!</h1>
    </header>
    <section>
      <span>Dear Valued Customer,<br /><br />
      For more than a decade we have made our leading menu design and printing software available to restaurants for free on our Free Plan. In recent years, the rising costs of doing business have forced us to make a difficult decision. As of {FINAL_DATE_FORMATTED}, 2025, our Free Plan will be discontinued. We are truly grateful to all who have been part of this journey!<br /><br />
        Our goal going forward is to provide outstanding menu creation at a reasonable price. Therefore, we are excited to introduce the new entry-level <b>Design Plan</b>.<br /><br />
The Design Plan will allow you to continue your MustHaveMenus account uninterrupted. It includes everything that you have already enjoyed. Plus, it offers unlimited access to all of our print-based templates, including all print menus and marketing. We've also added in the ability to share a viewable link to any of your menus.<br /><br />

        <b>The Design Plan is priced at $24/month or $228/year. </b><br /><br />

Please upgrade to the new Design Plan before the expiration date of {FINAL_DATE_FORMATTED}th to avoid any impact on your account access. If you wish to go up to our Pro plan, that works as well.<br /><br />

Thank you again for choosing MustHaveMenus. Please chat with our service team if you have any questions!</span>
      <br /><br />
      <span>Thank you,</span>
      <br />
      <span><CEOSignature /></span>
      <br />
      <span>Jim Williams</span>
    </section>
  </Modal>;
}
